import { render, staticRenderFns } from "./Spackage.vue?vue&type=template&id=7c27de07&"
import script from "./Spackage.vue?vue&type=script&lang=js&"
export * from "./Spackage.vue?vue&type=script&lang=js&"
import style0 from "./Spackage.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports